
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"360","height":"3","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h80v3H0z","fill":"#FF6C00"}}),_c('path',{attrs:{"d":"M80 0h70v3H80z","fill":"#FFBC00"}}),_c('path',{attrs:{"d":"M150 0h60v3h-60z","fill":"#81D501"}}),_c('path',{attrs:{"d":"M210 0h40v3h-40z","fill":"#01D5CD"}}),_c('path',{attrs:{"d":"M300 0h60v3h-60z","fill":"#0180D5"}}),_c('path',{attrs:{"d":"M250 0h50v3h-50z","fill":"#37D0FF"}})])])
          )
        }
      }
    